export default "__VITE_ASSET__BPu0jR5t__"